var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPirelli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 232.72 71.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#e1251b;}.d,.e{stroke-width:0px;}.e{fill:#ffd100;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 232.72,
    height: 71.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M86.04,39.02l-5.9.02v5.14h5.92c1.42,0,2.58-1.15,2.58-2.57s-1.16-2.59-2.6-2.59M68.34,34.45h25.01c4.06,0,7.36,3.29,7.36,7.36,0,3.1-1.91,5.76-4.63,6.85l5.15,7.43h-14.23l-3.67-6.91h-3.22v6.91h-11.78v-21.64Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "153.89 51.33 166.02 51.33 166.02 56.09 141.66 56.09 141.66 34.45 153.89 34.45 153.89 51.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "119.9 51.33 134.86 51.33 134.86 56.09 107.43 56.09 107.43 34.45 133.5 34.45 133.5 39.2 119.9 39.2 119.9 42.88 133.5 42.88 133.5 47.65 119.9 47.65 119.9 51.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "181.77 51.33 193.9 51.33 193.9 56.09 169.54 56.09 169.54 34.45 181.77 34.45 181.77 51.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M182.31,19.88H40.68v5.04h141.63c1.39,0,2.53-1.13,2.53-2.51s-1.14-2.52-2.53-2.52M20.05,14.89h185.03c4.18,0,7.57,3.38,7.57,7.57s-3.39,7.56-7.57,7.56H40.68v26.07h-20.62V14.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 48.61,
    y: 34.45,
    width: 11.78,
    height: 21.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 197.29,
    y: 34.45,
    width: 11.79,
    height: 21.64
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPirelli);
export default __webpack_public_path__ + "static/media/pirelli.556fc95046284f6a69c2ebbdc50b3ce1.svg";
export { ForwardRef as ReactComponent };